import React from 'react'
import { Edit } from 'react-admin'
import WithDeleteModalToolbar from 'ui-shared/CustomToolbars/WithDeleteModalToolbar'
import SectionWrapper from 'ui-shared/LayoutComponents/SectionWrapper'
import LocationForm from './LocationForm'

const LocationEdit: React.FC = () => {
  return (
    <SectionWrapper>
      <Edit>
        <LocationForm toolbar={<WithDeleteModalToolbar />} />
      </Edit>
    </SectionWrapper>
  )
}

export default LocationEdit
